<script setup lang="ts">
import { computed, ref } from 'vue';

import VButton from '@components/buttons/VButton/VButton.vue';
import { TRANSLATION_GROUP_ADMIN_PAYMENT_SYSTEM_DETAILS_PENDING_REQUESTS } from '@modules/payment-system-details/constants';
import { EReviewButtonVariants, EReviewPaymentSystemActionType } from '@modules/payment-system-details/types';

import type { IReviewPaymentSystemDetailsButtonsEmits, IReviewPaymentSystemDetailsButtonsProps } from './types';
import { PAYMENT_SYSTEM_DETAILS_PERMISSIONS } from '../../constants';

const props = withDefaults(defineProps<IReviewPaymentSystemDetailsButtonsProps>(), {
  variant: EReviewButtonVariants.PRIMARY,
});

const emit = defineEmits<IReviewPaymentSystemDetailsButtonsEmits>();

const currentActionType = ref(EReviewPaymentSystemActionType.APPROVE);

const isTextVariant = computed<boolean>(() => props.variant === EReviewButtonVariants.TEXT);

function onApprove(event: MouseEvent): void {
  currentActionType.value = EReviewPaymentSystemActionType.APPROVE;
  emit('approve', { id: props.id, event });
}

function onReject(event: MouseEvent): void {
  currentActionType.value = EReviewPaymentSystemActionType.REJECT;
  emit('reject', { id: props.id, event });
}
</script>

<template>
  <VButton v-data-qa-auto-id="'VReviewPaymentSystemButtons'"
    v-if="$hasPermission(PAYMENT_SYSTEM_DETAILS_PERMISSIONS.UPDATE)"
    :text="isTextVariant"
    :icon="isTextVariant ? undefined : 'pi-check-circle'"
    severity="success"
    :label="$getTranslation(TRANSLATION_GROUP_ADMIN_PAYMENT_SYSTEM_DETAILS_PENDING_REQUESTS, `${EReviewPaymentSystemActionType.APPROVE}_BUTTON_LABEL`)"
    :disabled="disabled || isLoading"
    :loading="isLoading && currentActionType === EReviewPaymentSystemActionType.APPROVE"
    @click="onApprove($event)"
  />
  <VButton
    v-if="$hasPermission(PAYMENT_SYSTEM_DETAILS_PERMISSIONS.UPDATE)"
    :text="isTextVariant"
    :icon="isTextVariant ? undefined : 'pi-times-circle'"
    severity="danger"
    :label="$getTranslation(TRANSLATION_GROUP_ADMIN_PAYMENT_SYSTEM_DETAILS_PENDING_REQUESTS, `${EReviewPaymentSystemActionType.REJECT}_BUTTON_LABEL`)"
    :disabled="disabled || isLoading"
    :loading="isLoading && currentActionType === EReviewPaymentSystemActionType.REJECT"
    @click="onReject($event)"
  />
</template>
